import LightboxUI from 'root/main/components/forms/lightbox/LightboxUI';
import FormLoader from 'root/main/components/forms/lightbox/FormLoader';

export default function lightboxFormInit(e: Event, url: string) {
    const lightboxUI = new LightboxUI();
    lightboxUI.clickHandler();
    const lightboxEl = lightboxUI.getLightboxEl;
    const formLoader = new FormLoader(lightboxEl, url);
    formLoader.load(e);
}
